import organizationUserFilters from '@/app/settings/organization/users/filters';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { cn } from '@/lib/cn';
import { toReadablePhoneNumber } from '@/lib/phone-number';
import { getOrganizationUserName } from '@/utils/organization-user/get-org-user-name';
import { type OrganizationUser } from '@pigello/pigello-matrix';
import { UserIcon } from 'lucide-react';
import Dot from './dot';
import type { RelationFieldProps } from './types';

export const OrganizationUserItem: RelationFieldProps<OrganizationUser> = {
  filters: organizationUserFilters,
  renderItem: (item, isRelationField) => ({
    title: getOrganizationUserName(item),
    avatar: (
      <Avatar className='size-8'>
        <AvatarImage
          className='object-cover'
          src={item?.profilePicture?.get}
          alt={getOrganizationUserName(item)}
        />
        <AvatarFallback className='text-xs'>
          <UserIcon className='size-4' />
        </AvatarFallback>
      </Avatar>
    ),
    badge: (
      <span className='text-xs'>
        {item.username ? `@${item.username}` : '-'}
      </span>
    ),
    descriptionItems: (
      <div
        className={cn(
          'flex items-center',
          isRelationField && 'w-full justify-between'
        )}
      >
        <div
          className={cn('truncate font-medium', isRelationField && 'max-w-44')}
        >
          {item.email ?? '-'}
        </div>
        {!isRelationField && <Dot />}
        <span>{toReadablePhoneNumber(item.phoneNumber) ?? '-'}</span>
      </div>
    ),
  }),
};
